import { useEffect, useState } from "react";
import api from "../../services/api";
import toastError from "../../errors/toastError";

// Los administradores pueden filtrar por todo el catálogo, aunque no tengan
// departamentos asignados. Los operadores conservan sus departamentos.
const useTicketQueues = (user) => {
  const isAdmin = user?.profile?.toUpperCase() === "ADMIN";
  const userId = user?.id;
  const [catalog, setCatalog] = useState({ userId: null, queues: [] });

  useEffect(() => {
    if (!isAdmin) return undefined;
    let active = true;
    setCatalog({ userId, queues: [] });

    (async () => {
      try {
        const { data } = await api.get("/queue");
        if (active) setCatalog({ userId, queues: data });
      } catch (err) {
        if (active) toastError(err);
      }
    })();

    return () => { active = false; };
  }, [isAdmin, userId]);

  return isAdmin
    ? (catalog.userId === userId ? catalog.queues : [])
    : (user?.queues || []);
};

export default useTicketQueues;
